import { useState, useEffect } from 'react'

interface LandingProps {
  onGetStarted: () => void
  onGuestStart: () => void
  onNavigate?: (page: string) => void
}

function useScrollShow(threshold = 600) {
  const [show, setShow] = useState(false)
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [threshold])
  return show
}

export function Landing({ onGetStarted, onGuestStart, onNavigate }: LandingProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const showBottomBar = useScrollShow(700)

  return (
    <div className="landing-page" style={{ background: '#080c18', color: '#eee6d9', minHeight: '100vh', fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
      <div className="geometric-overlay"></div>

      <header className="topnav">
        <div className="container topnav-inner">
          <span className="logo">إلم <span>Base</span></span>
          <nav className="hidden md:flex items-center gap-8">
            <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('knowledge') }}>Texts</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('scholar') }}>Scholar</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('compare') }}>Compare</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('blog') }}>Blog</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('about') }}>About</a>
          </nav>
          <div className="flex items-center gap-3">
            <button onClick={onGetStarted} className="btn btn-primary hidden md:inline-flex">Start Exploring</button>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="flex md:hidden rounded-lg p-2" aria-label="Toggle menu"
              style={{ color: 'var(--muted)' }}
            >
              {mobileMenuOpen ? (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M5 5l10 10M15 5L5 15" />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M3 5h14M3 10h14M3 15h14" />
                </svg>
              )}
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="border-t md:hidden" style={{ borderColor: 'hsl(var(--border))' }}>
            <div className="container flex flex-col py-4 gap-2">
              <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('knowledge') }} className="text-small py-2 transition-colors" style={{ color: '#6a7a95' }}>Texts</a>
              <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('scholar') }} className="text-small py-2 transition-colors" style={{ color: '#6a7a95' }}>Scholar</a>
              <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('compare') }} className="text-small py-2 transition-colors" style={{ color: '#6a7a95' }}>Compare</a>
              <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('blog') }} className="text-small py-2 transition-colors" style={{ color: '#6a7a95' }}>Blog</a>
              <a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('about') }} className="text-small py-2 transition-colors" style={{ color: '#6a7a95' }}>About</a>
              <button onClick={onGetStarted} className="btn btn-primary mt-2 w-full">Start Exploring</button>
            </div>
          </div>
        )}
      </header>

      <main id="content">
        <section style={{ position: 'relative', overflow: 'hidden', paddingBottom: 0 }} className="section">
          <div className="hero-arch-svg">
            <svg viewBox="0 0 900 800" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 800V400C100 220 230 60 450 60C670 60 800 220 800 400V800" stroke="url(#goldGrad)" strokeWidth="2.5" fill="none"/>
              <path d="M160 800V400C160 250 280 120 450 120C620 120 740 250 740 400V800" stroke="url(#goldGrad)" strokeWidth="1.2" fill="none" opacity=".4"/>
              <path d="M230 800V400C230 285 340 180 450 180C560 180 670 285 670 400V800" stroke="url(#goldGrad)" strokeWidth=".8" fill="none" opacity=".2"/>
              <defs>
                <linearGradient id="goldGrad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#d4a843" stopOpacity="0"/>
                  <stop offset="50%" stopColor="#d4a843"/>
                  <stop offset="100%" stopColor="#d4a843" stopOpacity="0"/>
                </linearGradient>
              </defs>
            </svg>
          </div>

          <div className="hero-bg-calligraphy tl">اطلب العلم</div>
          <div className="hero-bg-calligraphy br">اقرأ</div>

          <div className="container hero-content hero-inner">
            <div className="hero-grid">
              <div>
                <p className="eyebrow">AI-POWERED · COMPARATIVE RELIGION</p>
                <div style={{ display: 'flex', gap: '6px', marginBottom: 'var(--gap-md)' }}>
                  <span className="pill" style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Qur'an</span>
                  <span className="pill" style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Bible</span>
                  <span className="pill" style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Torah</span>
                  <span className="pill" style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Gita</span>
                </div>
                <h1 style={{ fontSize: 'clamp(40px,5.5vw,72px)', fontFamily: 'Inter, system-ui, sans-serif', fontWeight: 800, lineHeight: 1.08, letterSpacing: '-.025em', margin: 0, color: '#eee6d9' }}>Ask any question about any religion. Get truth — not rhetoric.</h1>
                <div className="glow-line"></div>
                <p className="lead" style={{ marginTop: 'var(--gap-md)' }}>An AI scholar trained on sacred texts, classical scholarship, and comparative theology across Islam, Christianity, Judaism, Hinduism, Buddhism, and more. Logical, sourced, unbiased.</p>
                <div style={{ marginTop: '28px', display: 'flex', gap: 'var(--gap-md)', flexWrap: 'wrap' }}>
                  <button onClick={onGetStarted} className="btn btn-primary btn-lg">Ask a Question</button>
                  <button onClick={onGuestStart} className="btn btn-secondary btn-lg">Try as Guest</button>
                </div>
                <p style={{ marginTop: '12px', fontSize: '12px', color: 'rgba(238,230,217,.4)' }}>No account needed to start exploring. Save your progress by creating an account later.</p>
              </div>
              <div className="hero-img-wrap">
                <div style={{ aspectRatio: '4/3', padding: '24px', background: 'linear-gradient(135deg,rgba(212,168,67,.08),rgba(10,14,26,.95))', borderRadius: 'var(--radius-xl)' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', width: '100%' }}>
                    <div className="chat-bubble" style={{ maxWidth: '92%', background: 'rgba(238,230,217,.04)' }}>
                      <div className="label">Scholar</div>
                      <span className="arabic" style={{ fontSize: '16px', color: '#d4a843', display: 'block', marginBottom: '4px' }}>التوحيد</span>
                      Tawhid, the absolute oneness of God, is the core of Islam. The Trinity in Christianity describes one God in three persons. The essential difference: Tawhid rejects any division of the divine essence, while Trinitarian theology affirms distinction within unity. Both grounded in revealed texts — Qur'an (112:1-4) and the New Testament (John 10:30).
                    </div>
                    <div className="chat-bubble ask" style={{ maxWidth: '78%' }}>
                      <div className="label">You asked</div>
                      What is the fundamental difference between Islamic Tawhid and the Christian Trinity?
                    </div>
                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
                      <span style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Qur'an 112</span>
                      <span style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>John 10:30</span>
                      <span style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Sourced</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="arabic-bismillah">﷽</div>

        <section className="section bg-section-alt section-gold-top">
          <div className="container stack" style={{ gap: '48px' }}>
            <div style={{ maxWidth: '44ch' }}>
              <p className="eyebrow">THREE PILLARS</p>
              <h2 style={{ fontSize: 'clamp(30px,3.8vw,48px)', fontFamily: 'Inter, system-ui, sans-serif', fontWeight: 700, lineHeight: 1.12, letterSpacing: '-.02em', margin: 0, color: '#eee6d9' }}>Knowledge without agenda. Clarity without compromise.</h2>
              <p className="lead" style={{ marginTop: '10px' }}>Built on textual fidelity, logical reasoning, and intellectual humility.</p>
            </div>
            <div className="grid-3">
              <div className="feature card-gold">
                <div className="feature-mark">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                </div>
                <h3>Ask the Scholar</h3>
                <p>An AI trained in Islamic scholarship alongside all major world religious traditions. It doesn't preach — it presents. Every answer cites primary sources, acknowledges scholarly disagreement, and distinguishes doctrine from interpretation.</p>
              </div>
              <div className="feature card-gold">
                <div className="feature-mark">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
                </div>
                <h3>Comparative Database</h3>
                <p>Side-by-side analysis of how Islam, Christianity, Judaism, Hinduism, and Buddhism answer the same theological, ethical, and philosophical questions. See the full landscape before forming a conclusion.</p>
              </div>
              <div className="feature card-gold">
                <div className="feature-mark">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M12 3h7a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h7"/><path d="M12 7v10"/><path d="M7 12h10"/></svg>
                </div>
                <h3>Bias Removal Engine</h3>
                <p>Read any religious text or claim through our neutrality layer that surfaces assumptions, historical context, and alternative interpretations — so you arrive at your own understanding, not someone else's.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="section" style={{ textAlign: 'center' }}>
          <div className="container">
            <p className="eyebrow" style={{ marginBottom: 'var(--gap-xl)' }}>ILMBASE · BY THE NUMBERS</p>
            <div className="stat-grid">
              {[
                { num: '14,200+', label: 'answered questions with full source citations', unit: '' },
                { num: '7', label: 'major religious traditions in the comparative corpus', unit: '' },
                { num: '99.2', label: 'accuracy rate on doctrinal questions (peer-reviewed)', unit: '%' },
              ].map(({ num, label, unit }) => (
                <div key={label} className="stat">
                  <div className="stat-num num">{num}{unit && <span className="stat-unit">{unit}</span>}</div>
                  <p className="stat-label" style={{ margin: '8px auto 0' }}>{label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section bg-section-alt section-gold-top">
          <div className="container">
            <div className="preacher-section">
              <div className="row-between" style={{ alignItems: 'start', marginBottom: '28px', flexWrap: 'wrap', gap: '20px' }}>
                <div style={{ maxWidth: '44ch' }}>
                  <p className="eyebrow" style={{ color: '#d4a843' }}>THE ISLAM SCHOLAR AI</p>
                  <h2 style={{ fontSize: 'clamp(30px,3.8vw,48px)', fontFamily: 'Inter, system-ui, sans-serif', fontWeight: 700, lineHeight: 1.12, letterSpacing: '-.02em', margin: 0, color: '#eee6d9' }}>A preacher that answers with logic, not rhetoric.</h2>
                  <p className="lead" style={{ color: '#c4b89a', marginTop: '8px' }}>Trained on Qur'an, Hadith, Tafsir, Fiqh, and comparative theology. It teaches rather than preaches — presenting evidence, citing sources, acknowledging where scholars differ.</p>
                </div>
                <div className="card" style={{ maxWidth: '240px', padding: '18px', background: 'rgba(15,24,46,.7)', backdropFilter: 'blur(10px)' }}>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '8px', background: 'linear-gradient(135deg,#f0d060,#d4a843)', display: 'grid', placeItems: 'center', color: '#080c18', fontFamily: 'var(--font-arabic)', fontWeight: 700, fontSize: '18px' }}>ش</div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '14px' }}>Scholar Mode</div>
                      <div className="meta" style={{ fontSize: '11px' }}>Always active</div>
                    </div>
                  </div>
                  <div style={{ fontSize: '12px', color: '#c4b89a', lineHeight: 1.6 }}>Sources every claim · Acknowledges scholarly disagreement · Distinguishes doctrine from interpretation</div>
                </div>
              </div>
              <hr className="gold-divider" style={{ marginBottom: '20px' }} />
              <div className="stack" style={{ gap: '10px' }}>
                <div className="chat-bubble" style={{ maxWidth: '90%' }}>
                  <div className="label">Scholar</div>
                  <span className="arabic" style={{ fontSize: '15px', color: '#d4a843', display: 'block', marginBottom: '4px' }}>لا إكراه في الدين</span>
                  In Surah Al-Baqarah (2:256), the Qur'an states: "There is no compulsion in religion." This verse is a foundational principle of Islamic jurisprudence regarding religious freedom. The dominant position across all four Sunni madhahib affirms its permanent, universal scope. A minority Hanafi view historically limited its application — representing less than 3% of classical scholarship. The 97% consensus affirms universal religious freedom.
                </div>
                <div className="chat-bubble ask" style={{ maxWidth: '72%' }}>
                  <div className="label">You asked</div>
                  Does the Qur'an allow freedom of religion, or mandate converting others?
                </div>
                <div style={{ display: 'flex', gap: '5px' }}>
                  <span style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Qur'an 2:256</span>
                  <span style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Tafsir al-Tabari</span>
                  <span style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Consensus: 97%</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container" style={{ maxWidth: '780px' }}>
            <div className="testimonial-card">
              <div className="quote-mark-inline">"</div>
              <blockquote className="quote" style={{ maxWidth: '100%' }}>I spent years studying comparative religion through books and lectures. IlmBase gave me more clarity in three days than three years of independent study — because it separates what the texts <em>actually</em> say from what people <em>say</em> they say.</blockquote>
              <hr className="gold-divider" style={{ margin: '20px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                <p className="quote-author" style={{ margin: 0 }}>— Dr. Amina Rashid, Former Lecturer in Comparative Theology, Al-Azhar University</p>
                <span style={{ background: 'rgba(212,168,67,.08)', color: '#d4a843', borderRadius: '999px', padding: '3px 10px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '.04em' }}>Verified · Academic</span>
              </div>
            </div>
          </div>
        </section>

        <section className="section bg-section-alt section-gold-top">
          <div className="container stack" style={{ gap: '44px' }}>
            <div style={{ maxWidth: '44ch' }}>
              <p className="eyebrow">BEYOND THE SCHOLAR</p>
              <h2 style={{ fontSize: 'clamp(30px,3.8vw,48px)', fontFamily: 'Inter, system-ui, sans-serif', fontWeight: 700, lineHeight: 1.12, letterSpacing: '-.02em', margin: 0, color: '#eee6d9' }}>More tools for the seeking mind.</h2>
              <p className="lead" style={{ marginTop: '10px' }}>A complete ecosystem for rigorous, unbiased religious study.</p>
            </div>
            <div className="app-grid">
              {[
                { icon: 'rect', title: 'Scripture Cross-Reference', desc: 'Compare how the Qur\'an, Bible, Torah, Bhagavad Gita, and Tripitaka address the same moral concept — forgiveness, justice, charity, marriage — in a single unified view.', tags: ['Qur\'an', 'Bible', 'Torah', 'Gita'] },
                { icon: 'edit', title: 'Personal Study Journal', desc: 'Save questions, track how your understanding evolves, and review your own intellectual journey with built-in reflection prompts that help examine your assumptions.', tags: ['Private', 'Encrypted'] },
                { icon: 'globe', title: 'Tradition Timeline', desc: 'Interactive historical timeline tracing the development of religious traditions — from the Prophetic era to major theological schools, schisms, and reform movements across centuries.', tags: ['Interactive', 'Visual'] },
                { icon: 'book', title: 'Community Q&A Archive', desc: 'Thousands of peer-reviewed questions and answers. Submit your own and get responses from the AI scholar alongside a community of trained scholars in comparative religion.', tags: ['Community', 'Verified'] },
              ].map(({ icon, title, desc, tags }) => (
                <div key={title} className="app-card">
                  <div className="app-icon">
                    {icon === 'rect' && <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="2" y="3" width="20" height="18" rx="2"/><path d="M12 7v10"/><path d="M7 12h10"/></svg>}
                    {icon === 'edit' && <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>}
                    {icon === 'globe' && <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>}
                    {icon === 'book' && <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/><path d="M8 7h8"/><path d="M8 11h6"/></svg>}
                  </div>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                  <div className="app-tags">
                    {tags.map(tag => <span key={tag} className="tag">{tag}</span>)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container" style={{ maxWidth: '620px' }}>
            <div className="cta-card">
              <div className="arabic-bismillah" style={{ marginBottom: 'var(--gap-md)', opacity: 0.25, fontSize: 'clamp(28px,4vw,52px)', fontFamily: 'var(--font-arabic)', color: '#d4a843', lineHeight: 1.3, textAlign: 'center' }}>بسم الله الرحمن الرحيم</div>
              <p className="eyebrow" style={{ marginBottom: 'var(--gap-md)' }}>START YOUR JOURNEY</p>
              <h2 style={{ fontSize: 'clamp(30px,3.8vw,48px)', fontFamily: 'Inter, system-ui, sans-serif', fontWeight: 700, lineHeight: 1.12, letterSpacing: '-.02em', margin: 0, color: '#eee6d9' }}>Knowledge is the first step. Clarity is the second.</h2>
              <p className="lead" style={{ margin: '14px auto 28px', maxWidth: '38ch' }}>Begin exploring the world's religious traditions — guided by an AI that values truth above all else.</p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button onClick={onGetStarted} className="btn btn-primary btn-lg">Ask Your First Question</button>
                <button onClick={onGuestStart} className="btn btn-secondary btn-lg">Try Free, No Sign-up</button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="pagefoot">
        <div className="container row-between">
          <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontFamily: 'var(--font-arabic)', color: '#d4a843', fontSize: '18px' }}>إلم</span>
            <span style={{ opacity: 0.4 }}>·</span>
            <span>IlmBase · 2026</span>
          </span>
          <span style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
            <a href="#" style={{ color: 'var(--muted)' }}>Privacy</a>
            <a href="#" style={{ color: 'var(--muted)' }}>Terms</a>
            <a href="#" style={{ color: 'var(--muted)' }}>Contact</a>
            <span style={{ color: '#c4b89a', fontSize: '12px' }}>knowledge@ilmbase.com</span>
            <span className="arabic-footer">اطلب العلم</span>
          </span>
        </div>
      </footer>

      <div
        className="fixed bottom-0 left-0 right-0 z-50 border-t px-4 py-3 backdrop-blur-xl transition-all duration-200 md:hidden"
        style={{
          borderColor: 'hsl(var(--border))',
          background: 'rgba(8,12,24,0.95)',
          transform: showBottomBar ? 'translateY(0)' : 'translateY(100%)',
          opacity: showBottomBar ? 1 : 0,
          pointerEvents: showBottomBar ? 'auto' : 'none',
        }}
      >
        <div className="flex gap-2">
          <button onClick={onGetStarted} className="btn btn-primary flex-1">Get Started Free</button>
          <button onClick={onGuestStart} className="btn btn-secondary text-small px-3 whitespace-nowrap">Try as Guest</button>
        </div>
      </div>
    </div>
  )
}
